import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiService } from '../../services/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { switchMap, mergeMap, catchError, throwError, map } from 'rxjs';
import {
  DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE,
  DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_LISTA_REPORT_PUNTO_POSTE,
  DOWNLOAD_LISTA_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_REPORT_PUNTO_POSTE,
  DOWNLOAD_REPORT_PUNTO_POSTE_LOCKER,
  DOWNLOAD_RETI_LOCKER,
  DOWNLOAD_RETI_TERZE,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS,
  RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS,
  RETRIEVE_REPORT_PUNTO_POSTE_LOCKER,
  RETRIEVE_REPORT_PUNTO_POSTE_LOCKER_SUCCESS,
  RETRIEVE_RETETERZA_REPORT,
  RETRIEVE_RETETERZA_REPORT_SUCCESS,
  RETRIEVE_RETILOCKER_REPORT,
  RETRIEVE_RETILOCKER_REPORT_SUCCESS,
} from './third-party-report.actions';
import { ResponseReteterzaReport } from '../../interfaces/response-reteterza-report';
import { RetrieveReteterzaReportPayload } from '../../interfaces/retrieve-reteterza-report-payload';
import { IPayloadPuntoPosteDetail } from '../../interfaces/retrive-report-punto-poste-payload';
import { IResponsePuntoPosteDetail } from '../../interfaces/retrive-dettaglio-punto-poste';
import { DOWNLOAD_FILE } from '../config/config.actions';
import { IResponseReportPuntoPoste } from '../../interfaces/response-report-punto-poste';
import { DownloadDetailReportPostPoint } from '../../interfaces/download-detail-report-post-point';
import { RetrieveRetilockerReportPayload } from '../../interfaces/retrieve-retiLocker-report-payload';
import { ResponseRetiLockerReport } from '../../interfaces/response-reti-locker-report';
import { IResponseReportPuntoPosteLocker } from '../../interfaces/response-report-punto-poste-locker';
import {
  IPayloadPuntoPosteLocker,
  IPayloadPuntoPosteLockerDetail,
} from '../../interfaces/retrieve-report-punto-poste-locker-payload';
import { IResponsePuntoPosteLockerDetail } from '../../interfaces/retrieve-punto-poste-locker-detail';
import { DownloadDetailReportPostPointLocker } from '../../interfaces/download-detail-report-post-point-locker';

@Injectable()
export class ThirdPartyReportEffects {
  retrieveConfig$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RETETERZA_REPORT),
      switchMap(({ payload }: { payload: RetrieveReteterzaReportPayload }) => {
        return this.api.retrieveReteterzaReport(payload);
      }),
      mergeMap((reteterzaReport: ResponseReteterzaReport) => {
        return [
          RETRIEVE_RETETERZA_REPORT_SUCCESS({
            reteterzaReport,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveRetiLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_RETILOCKER_REPORT),
      switchMap(({ payload }: { payload: RetrieveRetilockerReportPayload }) => {
        return this.api.retrieveRetiLockerReport(payload);
      }),
      mergeMap((retiLockerReport: ResponseRetiLockerReport) => {
        return [
          RETRIEVE_RETILOCKER_REPORT_SUCCESS({
            retiLockerReport,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrievePuntoPosteLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_REPORT_PUNTO_POSTE_LOCKER),
      switchMap(({ payload }: { payload: IPayloadPuntoPosteLocker }) => {
        return this.api.visualizzaReportPuntoPosteLocker(payload);
      }),
      mergeMap((reponsePuntoPosteLocker: IResponseReportPuntoPosteLocker) => {
        return [
          RETRIEVE_REPORT_PUNTO_POSTE_LOCKER_SUCCESS({
            reponsePuntoPosteLocker,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveDetailPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_DETTAGLIO_PUNTO_POSTE),
      switchMap(({ payload }: { payload: IPayloadPuntoPosteDetail }) => {
        return this.api.dettaglioReportPuntoPoste(payload);
      }),
      mergeMap((dettaglioPuntoPoste: IResponsePuntoPosteDetail) => {
        return [
          RETRIEVE_DETTAGLIO_PUNTO_POSTE_SUCCESS({
            dettaglioPuntoPoste,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  retrieveDetailPuntoPosteLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER),
      switchMap(({ payload }: { payload: IPayloadPuntoPosteLockerDetail }) => {
        return this.api.dettaglioReportPuntoPosteLocker(payload);
      }),
      mergeMap((dettaglioPuntoPosteLocker: IResponsePuntoPosteLockerDetail) => {
        return [
          RETRIEVE_DETTAGLIO_PUNTO_POSTE_LOCKER_SUCCESS({
            dettaglioPuntoPosteLocker,
          }),
        ];
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_REPORT_PUNTO_POSTE),
      switchMap(
        ({ payload }: { payload: Partial<IResponsePuntoPosteDetail> }) => {
          return this.api.downloadReportPuntoPoste(payload);
        }
      ),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_CP_Detail.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportPuntoPosteLista$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_LISTA_REPORT_PUNTO_POSTE),
      switchMap(
        ({ payload }: { payload: Partial<IResponseReportPuntoPoste> }) => {
          return this.api.downloadReportPuntoPosteLista(payload);
        }
      ),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_CP.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadDettaglioReportPuntoPoste$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE),
      switchMap(({ payload }: { payload: DownloadDetailReportPostPoint }) => {
        return this.api.downloadDettaglioReportPuntoPoste(payload);
      }),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_Dettaglio_RT.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadRetiTerze$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_RETI_TERZE),
      switchMap(
        ({ payload }: { payload: Partial<ResponseReteterzaReport> }) => {
          return this.api.downloadRetiTerze(payload);
        }
      ),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_RT.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadRetiLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_RETI_LOCKER),
      switchMap(({ payload }: { payload: RetrieveRetilockerReportPayload }) => {
        return this.api.downloadRetiLocker(payload);
      }),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_RL.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadDettaglioReportPuntoPosteLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_DETTAGLIO_REPORT_PUNTO_POSTE_LOCKER),
      switchMap(
        ({ payload }: { payload: DownloadDetailReportPostPointLocker }) => {
          return this.api.downloadDettaglioReportPuntoPosteLocker(payload);
        }
      ),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_Dettaglio_RL.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportPuntoPosteListaLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_LISTA_REPORT_PUNTO_POSTE_LOCKER),
      switchMap(({ payload }: { payload: IPayloadPuntoPosteLocker }) => {
        return this.api.downloadReportPuntoPosteListaLocker(payload);
      }),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_CPL.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  downloadReportPuntoPosteLocker$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(DOWNLOAD_REPORT_PUNTO_POSTE_LOCKER),
      switchMap(
        ({
          payload,
        }: {
          payload: Partial<IResponsePuntoPosteLockerDetail>;
        }) => {
          return this.api.downloadReportPuntoPosteLocker(payload);
        }
      ),
      map((file: Blob) => {
        return DOWNLOAD_FILE({ file, fileName: 'Report_CPL_Detail.xlsx' });
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError({ error });
      })
    );
  });

  constructor(private actions$: Actions, private api: ApiService) {}
}
